import { Theme, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { FormInputCheckbox } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputCheckbox';
import { FormInputText } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputText';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import moment from 'moment';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  selectIslandsCancel,
  selectPlacementHeaderData,
  selectPlacementLandsGtgDetails,
} from '../../../../../../../store/redux-store/placement-details/selectors';
const useStyles = makeStyles()((theme: Theme) =>
  ({
    root: {
      padding: '0px 15px',
    },
    alignItem: {
      paddingLeft: '18px !important',
    },
    itemStyle: {
      height: '125',
    },
    alingmentField: {
      paddingLeft: '6px !important',
      paddingRight: '25px !important',
    },
    licenseSubSections: {
      marginBottom: 12,
      marginLeft: -7,
      fontSize: 16,
    },
  }));
export const LandsLicenseFields = props => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const placementDetails = useSelector(selectPlacementHeaderData);
  const selectLandsGtgDetails = useSelector(selectPlacementLandsGtgDetails);
  const selectIsCancel = useSelector(selectIslandsCancel);
  const [showReason, setShowReason] = React.useState(!selectLandsGtgDetails?.confirmCaLicense);
  const { getValues, setValue } = useFormContext();

  React.useEffect(() => {
    setValue('licenseActive', selectLandsGtgDetails?.licenseActive);
    setValue('licenseReviewCleared', selectLandsGtgDetails?.licenseReviewTeamClearedHits);
    setValue('licenseMatchAudit', selectLandsGtgDetails?.hitsOnLicenseMatchAudit);
    setValue('auditScreened', selectLandsGtgDetails?.auditScreenedWithClient);
    setValue('datesCheckbox1', selectLandsGtgDetails?.licenseIssuedAfterGraduation);
    setValue('datesCheckbox2', selectLandsGtgDetails?.checkedDob);
    setValue('datesCheckbox3', selectLandsGtgDetails?.confirmCaLicense);
    setValue('reason', selectLandsGtgDetails?.confirmCaLicenseReason);
    setValue('proofOfResidency', selectLandsGtgDetails?.isProofOfResidencyOnFileForCompact);
    setShowReason(!selectLandsGtgDetails?.confirmCaLicense);
    if (props.licenseMetaData.licenseNumber == selectLandsGtgDetails?.licenseNumber) {
      props.handleFieldChanges?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectLandsGtgDetails, setValue, selectIsCancel]);

  React.useEffect(() => {
    if (props.licenseMetaData.licenseNumber !== selectLandsGtgDetails?.licenseNumber) {
      setValue('licenseActive', false);
      setValue('licenseReviewCleared', false);
      setValue('licenseMatchAudit', false);
      setValue('auditScreened', false);
      setValue('datesCheckbox1', false);
      setValue('datesCheckbox2', false);
      setValue('datesCheckbox3', false);
      setValue('reason', null);
      setValue('proofOfResidency', false);
      setShowReason(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.licenseMetaData]);

  React.useEffect(() => {
    setShowReason(!getValues('datesCheckbox3'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getValues('datesCheckbox3')]);

  const toggleShowReason = event => {
    setShowReason(!event);
    handleChange(event, 7);
    setValue('reason', null);
    setValue('datesCheckbox3', event, { shouldDirty: true });
  };

  const handleReasonChange = event => {
    setValue('reason', event.target.value);
    props.handleFieldChanges?.();
  };

  const handleChange = (event, key) => {
    if (key === 1) setValue('licenseActive', event, { shouldDirty: true });
    if (key === 2) setValue('licenseReviewCleared', event, { shouldDirty: true });
    if (key === 3) setValue('licenseMatchAudit', event, { shouldDirty: true });
    if (key === 4) setValue('auditScreened', event, { shouldDirty: true });
    if (key === 5) setValue('datesCheckbox1', event, { shouldDirty: true });
    if (key === 6) setValue('datesCheckbox2', event, { shouldDirty: true });
    if (key === 7) setValue('proofOfResidency', event, { shouldDirty: true });
    props.handleFieldChanges?.();
  };

  return (
    <>
      <LayoutGrid container direction="column" className={classes.root} spacing={4}>
        <LayoutGridItem item className={`${classes.alignItem} ${classes.itemStyle}`}>
          <LayoutGrid container direction="row" data-testid="container" justifyContent="flex-start">
            <LayoutGridItem item xs={12} className={classes.alingmentField}>
              <Typography variant="subtitle2" className={classes.licenseSubSections}>
                {t(
                  'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.landsLicenseFields.activeActions',
                )}
              </Typography>
              <LayoutGrid direction="column">
                <LayoutGridItem>
                  <FormInputCheckbox
                    name="licenseActive"
                    isChecked={getValues('licenseActive') || false}
                    handleChecked={event => handleChange(event, 1)}
                    checkboxLabel={t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.landsLicenseFields.licenseActive',
                    )}
                    isDisabled={false}
                  />
                </LayoutGridItem>
                <LayoutGridItem>
                  <FormInputCheckbox
                    name="licenseReviewCleared"
                    isChecked={getValues('licenseReviewCleared') || false}
                    handleChecked={event => handleChange(event, 2)}
                    checkboxLabel={t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.landsLicenseFields.licenseReviewTeamCleared',
                    )}
                    isDisabled={false}
                  />
                </LayoutGridItem>
                <LayoutGridItem>
                  <FormInputCheckbox
                    name="licenseMatchAudit"
                    isChecked={getValues('licenseMatchAudit') || false}
                    handleChecked={event => handleChange(event, 3)}
                    checkboxLabel={t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.landsLicenseFields.confirmedHitsLicenseMatchAuditFile',
                    )}
                    isDisabled={false}
                  />
                </LayoutGridItem>
                <LayoutGridItem>
                  <FormInputCheckbox
                    name="auditScreened"
                    isChecked={getValues('auditScreened') || false}
                    handleChecked={event => handleChange(event, 4)}
                    checkboxLabel={t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.landsLicenseFields.auditScreenedClient',
                    )}
                    isDisabled={false}
                  />
                </LayoutGridItem>
              </LayoutGrid>
            </LayoutGridItem>
          </LayoutGrid>
        </LayoutGridItem>
        <LayoutGridItem item className={`${classes.alignItem} ${classes.itemStyle}`}>
          <LayoutGrid container direction="row" data-testid="container" justifyContent="flex-start">
            <LayoutGridItem item xs={12} className={classes.alingmentField}>
              <Typography variant="subtitle2" className={classes.licenseSubSections}>
                {t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.landsLicenseFields.dates')}
              </Typography>
              <LayoutGrid direction="column">
                <LayoutGridItem>
                  <FormInputCheckbox
                    name="datesCheckbox1"
                    isChecked={getValues('datesCheckbox1') || false}
                    handleChecked={event => handleChange(event, 5)}
                    checkboxLabel={t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.landsLicenseFields.issuedAfterGraduationDate',
                    )}
                    isDisabled={false}
                  />
                </LayoutGridItem>
                <LayoutGridItem>
                  <FormInputCheckbox
                    name="datesCheckbox2"
                    isChecked={getValues('datesCheckbox2') || false}
                    handleChecked={event => handleChange(event, 6)}
                    checkboxLabel={`${t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.landsLicenseFields.dob',
                    )} (${moment(placementDetails?.candidate?.dob?.dob).format('MM/DD/YYYY')}) ${t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.landsLicenseFields.alignsWithGraduationDate',
                    )}`}
                    isDisabled={false}
                  />
                </LayoutGridItem>
                {(props.licenseMetaData.stateID === 5 || props.licenseMetaData.levelID === 307) && (
                  <>
                    <LayoutGridItem>
                      <FormInputCheckbox
                        name="datesCheckbox3"
                        isChecked={getValues('datesCheckbox3') || false}
                        handleChecked={toggleShowReason}
                        checkboxLabel={`${t(
                          'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.landsLicenseFields.expirationDate',
                        )} (${moment(props.licenseMetaData?.expirationDate).format('MM/DD')}) ${t(
                          'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.landsLicenseFields.endOfMonthFollowing',
                        )} (${moment(placementDetails?.candidate.dob?.dob).format('MM/DD')})`}
                        isDisabled={false}
                      />
                    </LayoutGridItem>
                    {showReason && (
                      <LayoutGridItem>
                        <FormInputText
                          name={'reason'}
                          label={t(
                            'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.landsLicenseFields.ifNoEnterReason',
                          )}
                          handleChange={handleReasonChange}
                          require={false}
                          readOnly={!showReason}
                          inputValue={selectLandsGtgDetails?.confirmCaLicenseReason || ''}
                          isCheckBox={true}
                        />
                      </LayoutGridItem>
                    )}
                  </>
                )}
              </LayoutGrid>
            </LayoutGridItem>
          </LayoutGrid>
        </LayoutGridItem>
        {props.licenseMetaData.levelID == 307 && (
          <LayoutGridItem item className={`${classes.alignItem} ${classes.itemStyle}`}>
            <LayoutGrid container direction="row" data-testid="container" justifyContent="flex-start">
              <LayoutGridItem item xs={12} className={classes.alingmentField}>
                <Typography variant="subtitle2" className={classes.licenseSubSections}>
                  {t(
                    'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.landsLicenseFields.compactState',
                  )}
                </Typography>
                <LayoutGrid direction="column">
                  <LayoutGridItem>
                    <FormInputCheckbox
                      name="proofOfResidency"
                      isChecked={getValues('proofOfResidency') || false}
                      handleChecked={event => handleChange(event, 7)}
                      checkboxLabel={t(
                        'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.landsLicenseFields.proofResidencyCompactStateOnFile',
                      )}
                      isDisabled={false}
                    />
                  </LayoutGridItem>
                </LayoutGrid>
              </LayoutGridItem>
            </LayoutGrid>
          </LayoutGridItem>
        )}
      </LayoutGrid>
    </>
  );
};
